export let competitionPracticePlan = [
    {prop: 'schemeName', label: '计划名称'},
    {prop: 'professionName', label: '专业类型', width: '80'},
    {prop: 'raceName', label: '大赛类型', width: '80'},
    {prop: 'planTime', label: '计划时间'},
    {prop: 'paperNum', label: '试卷数量', width: '80'},
    {prop: 'applyNum', label: '报名数量', width: '80'},
    {prop: 'passNum', label: '审核通过', width: '80'},
    {prop: 'schemeStatusName', label: '计划状态', width: '80'}
]

export let provinceList = [
    {prop: 'name', label: '省份'},
    {prop: 'beginTime', label: '开始日期'},
    {prop: 'endTime', label: '结束日期'},
]

export let examPaperDisplayList = [
    {prop: 'paperName', label: '试卷名称'},
    {prop: 'subjectName',label: '科目分类' },
    {prop: 'createTime', label: '创建时间'}
]

// export let paperTestHeaderData = [
//     {prop: 'paperName', label: '试卷名称'},
//     {prop: 'subjectName',label: '科目分类' },
//     {prop: 'createTime', label: '创建时间'}
// ]

export let orgTypeDisplayList = [
    {prop: 'orgName', label: '院校名称'},
    {prop: 'provinceName', label: '所属省份', width: '100'},
    {prop: 'orgTypeName', label: '机构类型', width: '80'},
    {prop: 'orgTime', label: '开通时段'},
    {prop: 'orgStatusText', label: '开通状态', width: '80'}
]
    